import React, { useState, useEffect } from 'react';
import './App.css';
import { LanguageProvider } from './context/LanguageContext';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import About from './pages/About';
import Gallery from './pages/Gallery';
import Tenders from './pages/Tenders';
import Events from './pages/Events';
import Committee from './pages/Committee';
import Location from './pages/Location';
import Donation from './pages/Donation';
import Contact from './pages/Contact';
import Download from './pages/download';
import Darshan from './pages/Darshan';
import Footer from './components/Footer';
// import BannerSplash from './components/BannerSplash';

function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    if (!showSplash) return;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    const t = setTimeout(() => setShowSplash(false), 1800);
    return () => {
      clearTimeout(t);
      document.body.style.overflow = previousOverflow;
    };
  }, [showSplash]);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.pageYOffset > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const renderPage = () => {
    switch(currentPage) {
      case 'home': return <Home setCurrentPage={setCurrentPage} />;
      case 'about': return <About />;
      case 'gallery': return <Gallery />;
      case 'tenders': return <Tenders />;
      case 'events': return <Events setCurrentPage={setCurrentPage} />;
      case 'committee': return <Committee />;
      case 'location': return <Location />;
      case 'aaras-download': return <Download />;
      case 'donation': return <Donation />;
      case 'contact': return <Contact />;
      default: return <Home />;
    }
  };

  return (
    <LanguageProvider>
      <div className="App">
        {/* Crimson banner splash — only on first home page load */}
        {/* {showSplash && currentPage === 'home' && <BannerSplash />} */}
        {showSplash && (
          <div className="app-splash" role="status" aria-label="Loading">
            <img
              src="/Assets/Logo3.png"
              alt="Shrinath Mhaskoba Mandir"
              className="app-splash__logo"
              loading="eager"
              decoding="async"
            />
          </div>
        )}
        <Navbar currentPage={currentPage} setCurrentPage={setCurrentPage} />
        <main>
          {renderPage()}
        </main>
        <Footer setCurrentPage={setCurrentPage} />
        
        {showScrollTop && (
          <button className="scroll-to-top" onClick={scrollToTop}>
            ↑
          </button>
        )}
      </div>
    </LanguageProvider>
  );
}

export default App;
